/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierPlan.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/carrier-plan";

export class AutogenModelCarrierPlan<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierPlanFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierPlan extends ModelRow<RowCarrierPlanFields> {
	constructor(values?: Partial<RowCarrierPlanFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierPlanFields {
	company_id: string;
	descr: string;
	id: string;
	type_of: string;
}

